import uniqBy from "lodash/uniqBy";
import {
    FETCH_CONTACTS,
    DELETE_CONTACT,
    ADD_CONTACT,
    TOGGLE_BAN_CONTACT,
    UPDATE_CONTACT,
} from "../actions/type";
export default function contacts(state = { items: [], query: null }, action) {
    switch (action.type) {
        case FETCH_CONTACTS:
            // TODO refactor it (low code quality)
            if (action.payload.query) {
                if (action.payload.query !== state.query) {
                    return {
                        items: [...action.payload.items],
                        query: action.payload.query,
                    };
                } else {
                    return {
                        items: uniqBy([...state.items, ...action.payload.items], "contact_id"),
                        query: action.payload.query,
                    };
                }
            }
            if (state.query) {
                return {
                    items: [...action.payload.items],
                    query: null,
                };
            }
            return {
                items: uniqBy([...state.items, ...action.payload.items], "contact_id"),
            };
        case DELETE_CONTACT:
            const newContacts = state.items.filter(
                (contact) => contact.contact_id !== action.payload,
            );
            return {
                items: newContacts,
            };
        case TOGGLE_BAN_CONTACT:
            const item = state.items.find((contact) => contact.contact_id === action.payload);
            if (item) {
                item.employee.isBlock = !item.employee.isBlock;
            }
            return {
                items: state.items,
            };
        case ADD_CONTACT:
            return {
                ...state,
                items: uniqBy([action.payload, ...state.items], "contact_id"),
            };
        case UPDATE_CONTACT:
            const contact = state.items.find((el) => el.contact_id === action.payload.user_id);
            if (contact) {
                return {
                    items: [
                        contact,
                        ...state.items.filter((el) => el.contact_id !== action.payload.user_id),
                    ],
                };
            }

            return state;
        default:
            return { ...state };
    }
}
